// src/pages/BlogPage.js
import React, { useEffect, useState } from 'react';
import client from '../contentfulClient';
import { Link } from 'react-router-dom';
import './BlogPage.css'; // Your CSS for the blog list

const BlogPage = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await client.getEntries({
          content_type: 'blogPost', // Your Content Model's API ID
          order: '-fields.publishDate' // Order by publish date, newest first
        });
        setBlogPosts(response.items);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching blog posts:", err);
        setError(err);
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  if (loading) return <div className="blog-loading">Loading Roomease blog posts...</div>;
  if (error) return <div className="blog-error">Error loading blog posts: {error.message}</div>;
  if (blogPosts.length === 0) return <div className="blog-empty">No Roomease blog posts found yet. Time to write!</div>;

  return (
    <div className="roomease-blog-list-container">
      <h1>RoomEase Insights: Our Blogs</h1>
      <div className="blog-posts-grid">
        {blogPosts.map((post) => (
          <Link to={`/blogs/${post.fields.slug}`} key={post.sys.id} className="blog-post-card-link">
            <div className="roomease-blog-post-card">
              {post.fields.featuredImage && (
                <img
                  src={post.fields.featuredImage.fields.file.url}
                  alt={post.fields.featuredImage.fields.description || post.fields.title}
                  className="roomease-blog-card-image"
                />
              )}
              <div className="roomease-card-content">
                <h2>{post.fields.title}</h2>
                <p className="roomease-blog-author">By {post.fields.author} on {new Date(post.fields.publishDate).toLocaleDateString()}</p>
                {/* Removed the excerpt text here */}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;